module.exports = __webpack_public_path__ + "7e13e844bb998178bba58f75f2aed66a.svg";